import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row research-items-container iodine-padding-left-sm iodine-padding-right-sm" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "source-data" }

import { EditData } from 'src/contracts/edit';

export interface Props {
    sectionName: string,
    items: Array<EditData>,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditsSectionContainer',
  props: {
    sectionName: { default: '' },
    items: {}
  },
  setup(__props: any) {


const props = __props;

function hoverText(level: string): string {
    if (level === 'Critical') {
        return 'Critical Error doesn\'t allow override and DRG calculation cannot be completed.';
    }

    return 'Error Warning Does allow an override. TruBridge Encoder supplies the edit but it is up to the coder to ' +
        'determine if or how the edit should be resolved. DRG calculation can be completed, but inaccuracies may occur.';
}


return (_ctx: any,_cache: any) => {
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (!_ctx.items || _ctx.items.length == 0)
    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
        key: 0,
        class: "edits-section-title",
        label: props.sectionName,
        disable: true
      }, null, 8, ["label"]))
    : (_openBlock(), _createBlock(_component_q_expansion_item, {
        key: 1,
        class: "edits-section-title",
        label: props.sectionName,
        "default-opened": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_list, { dense: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createBlock(_component_q_item, { key: item }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        class: _normalizeClass(["edit-flag", item.level == 'Critical' ? 'critical' : 'warning']),
                        name: "fa-solid fa-flag"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, { "max-width": "300px" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(hoverText(item.level)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class"]),
                      _createElementVNode("p", null, [
                        _createElementVNode("span", {
                          innerHTML: item.description
                        }, null, 8, _hoisted_2),
                        _createTextVNode("   "),
                        _createElementVNode("span", _hoisted_3, _toDisplayString(item.source_data), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["label"]))
}
}

})